import Link from 'next/link';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';
import ExportedImage from '@/components/shared/ExportedImage';

import { communitySocialLinks } from '@/data/configs/communitySocialLinks';

export const JoinCommunity = () => {
  return (
    <>
      <section className='my-20 text-center text-white lg:my-24 2xl:my-36'>
        <div className='dummy hidden w-[50.21px] w-[70.21px] lg:w-[125.21px] lg:w-[90.21px]'></div>
        <h2 className='mx-auto mb-[10px] max-w-[756px] font-heading text-3xl font-semibold text-white sm:text-4xl lg:text-5xl'>
          Join the Best Blockchain
          <br /> Community
        </h2>
        <p className='text-base font-normal leading-[18px] -sm:mb-6'>
          Follow our socials to stay updated!
        </p>
        <div className='mx-auto flex w-full max-w-[640px] flex-wrap items-center justify-center gap-4 px-4 pt-4 sm:pt-8 lg:pt-[46px]'>
          {communitySocialLinks.map((social, i) => {
            const { name, icon, link } = social;
            return (
              <AnimateWhileInView delay={(i + 2) * 0.1} key={social.name}>
                <Link
                  href={link}
                  aria-label={name}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='all-index-join_community-social flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-110 active:scale-95'
                >
                  <ExportedImage
                    placeholder='empty'
                    src={icon}
                    alt={name}
                    className='h-[70px] w-[70px] object-contain sm:h-[90px] sm:w-[90px]'
                  />
                </Link>
              </AnimateWhileInView>
            );
          })}
        </div>
      </section>
    </>
  );
};
